export default __webpack_public_path__ + "static/camera-ec54bb1aae9f50cb3d21ff424535ed31.svg";